import { useModal } from '../context/modals/useModal';
import { CreateLabelModal } from './CreateLabelModal';
import { LabelDropdown } from './LabelDropdown';
import TagIcon from './icons/TagIcon';
import { Label } from '../types/kanban';

interface CardLabelsProps {
  labels: Label[];
  cardLabels: Label[];
  addLabel: (name: string, color: string) => Promise<boolean>;
  addLabelToCard: (labelId: number) => Promise<boolean>;
  removeLabelFromCard: (labelId: number) => Promise<boolean>;
  refetchLabels: () => Promise<Label[]>;
  refetchCard: () => Promise<any>;
}

export function CardLabels({
  labels,
  cardLabels,
  addLabel,
  addLabelToCard,
  removeLabelFromCard,
  refetchLabels,
  refetchCard,
}: CardLabelsProps) {
  const { openModal } = useModal();

  const handleCreateLabel = () => {
    openModal((props) => (
      <CreateLabelModal
        onSave={async (name, color) => {
          const success = await addLabel(name, color);
          if (success) {
            // Refetch both labels and card data to show new labels
            await refetchLabels();
            await refetchCard();
          }
          return success;
        }}
        onClose={props.onClose}
      />
    ));
  };

  return (
    <div className="bg-gray-800 rounded-lg p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-white flex items-center gap-2">
          <span className="w-5 h-5">
            <TagIcon />
          </span>
          Labels
        </h2>
        <LabelDropdown
          labels={labels}
          cardLabels={cardLabels}
          onAddLabel={addLabelToCard}
          onRemoveLabel={removeLabelFromCard}
          onCreateLabel={handleCreateLabel}
        />
      </div>
      <div className="flex flex-wrap gap-2">
        {cardLabels && cardLabels.length > 0 ? (
          cardLabels.map((label) => (
            <span
              key={label.id}
              className="px-3 py-1 rounded-full text-sm font-medium"
              style={{ backgroundColor: label.color, color: 'white' }}
            >
              {label.name}
            </span>
          ))
        ) : (
          <p className="text-gray-400 text-sm">No labels added to this card</p>
        )}
      </div>
    </div>
  );
}
